module.exports = __webpack_public_path__ + "static/img/default.6b914f9c.jpg";